import { CubeIcon } from '@heroicons/react/24/outline'
import clsx from 'clsx'

interface LogoProps {
  className?: string
  size?: 'sm' | 'md' | 'lg' | 'xl'
  variant?: 'filled' | 'bare'
}

export default function Logo({ className, size = 'md', variant = 'filled' }: LogoProps) {
  if (variant === 'bare') {
    const icon = size === 'xl' ? 'h-16 w-16' : size === 'lg' ? 'h-10 w-10' : 'h-8 w-8'
    return <CubeIcon className={clsx('text-indigo-600', icon, className)} />
  }

  const dims = size === 'sm' ? 'h-7 w-7' : size === 'lg' ? 'h-10 w-10' : 'h-8 w-8'
  const icon = size === 'sm' ? 'h-5 w-5' : size === 'lg' ? 'h-7 w-7' : 'h-6 w-6'
  return (
    <div className={clsx('flex shrink-0 items-center justify-center rounded-lg bg-indigo-600', dims, className)}>
      <CubeIcon className={clsx('text-white', icon)} />
    </div>
  )
}
